// eslint-disable-next-line import/no-cycle
import userMutations from './userMutations'

const mutations = {
  ...userMutations,
}

export default mutations
